/*
 * lists
 */
docready(function() {
	document.querySelectorAll('.list-container').forEach(function(list) {
		initList(list);
	});
});


function initList(list) {
	// filtres
	let filtersForm = list.querySelector('.list-filters');
	if (filtersForm) {
		filtersForm.addEventListener('submit', function(event) {
			event.preventDefault();
			reloadList(list);
		});
		filtersForm.querySelector('[data-filters-reset]').addEventListener('click', function(event) {
			event.preventDefault();
			
			for (i = 0; i < filtersForm.elements.length; i++) {
				field_type = filtersForm.elements[i].type.toLowerCase();
				switch (field_type) {
					case 'text':
					case 'password':
					case 'textarea':
					case 'hidden':
						filtersForm.elements[i].value = '';
						break;
					case 'radio':
					case 'checkbox':
						if ( filtersForm.elements[i].value == '' )
							filtersForm.elements[i].checked = true;
						else if (filtersForm.elements[i].checked)
							filtersForm.elements[i].checked = false;
						break;
					case 'select-one':
					case 'select-multi':
						filtersForm.elements[i].selectedIndex = 0;
						break;
					default:
						break;
				}
			}

			const btnCombineOu = filtersForm.querySelector('#combine_ou');
			if ( btnCombineOu ) {
				btnCombineOu.checked = true;
			}

			filtersForm.querySelectorAll('.selectmulti button').forEach(function(btn) {
				btn.querySelector('span').textContent = btn.dataset.text;
			});
			reloadList(list);
		});
	}

	loadListEvents(list);
}


function reloadList(list, page = 1) {
	list.classList.add('_loading');
	let baseUrl = list.dataset.baseurl;
	let params = new FormData();

	let filters = {};
	let filtersForm = list.querySelector('.list-filters');
	let formEmpty = true;
	if (filtersForm) {
		let data = new FormData(filtersForm);
		for (let [key, value] of data.entries()) {
			if ( value !== '' ) {
				let isArray = false;
				if ( isArray = key.match(/(.+)\[(.+)\]/) ) {
					if ( !filters.hasOwnProperty(isArray[1]) ) {
						filters[isArray[1]] = {};
					}
					filters[isArray[1]][isArray[2]] = value;
					console.log(isArray[2]);
				}
				else {
					if (filters[key] !== undefined) {
						if (!Array.isArray(filters[key])) {
							filters[key] = [filters[key]];
						}
						filters[key].push(value);
					} else {
						filters[key] = value;
					}
				}
				if (formEmpty && value !== '')
					formEmpty = false;
			}
		}
		if (formEmpty)
			filtersForm.querySelector('[data-filters-reset]').classList.add('d-none');
		else
			filtersForm.querySelector('[data-filters-reset]').classList.remove('d-none');
	}

	params.append('sort', list.dataset.sort);
	params.append('order', list.dataset.order);
	if (!formEmpty)
		params.append('filters', JSON.stringify(filters));
	params.append('p', page);

	baseUrl += '&' + new URLSearchParams(params).toString();
	if ( list.dataset.noUpdateUrl === undefined )
		history.replaceState(null, '', baseUrl);

	fetch(baseUrl, {
		method: 'GET',
		headers: { 'X-Requested-With': 'XMLHttpRequest' },
	})
	.then(response => response.text())
	.then(function(data) {
		list.querySelector('.list-wrapper').innerHTML = data;
		loadListEvents(list);
		list.classList.remove('_loading');
	});
}

function loadListEvents(list) {
	// sort
	list.querySelectorAll('[data-sort-field][data-sort-order]').forEach(function(orderLink) {
		orderLink.addEventListener('click', function(event) {
			event.preventDefault();
			list.dataset.sort = orderLink.dataset.sortField;
			list.dataset.order = orderLink.dataset.sortOrder;
			reloadList(list);
		});
	});

	// pagination
	list.querySelectorAll('[data-reload]').forEach(function(reloadLink) {
		reloadLink.addEventListener('click', function(event) {
			event.preventDefault();
			reloadList(list);
		});
	});

	// pagination
	list.querySelectorAll('.page-item:not(.disabled) a[data-page]').forEach(function(pageLink) {
		pageLink.addEventListener('click', function(event) {
			event.preventDefault();
			reloadList(list, pageLink.dataset.page);
			document.querySelector('.list-container').scrollIntoView({ 
				behavior: 'smooth' 
			});
		});
	});

	// toggle
	list.querySelectorAll('[data-toggle]').forEach(function(toggleLink) {
		toggleLink.addEventListener('click', function(event) {
			event.preventDefault();

			let formData = new FormData();
			formData.append('action', 'toggleactive');
			formData.append('id', toggleLink.dataset.toggle);

			fetch('', {
				method: 'POST',
				headers: { 'X-Requested-With': 'XMLHttpRequest' },
				body: new URLSearchParams(formData)
			})
			.then(response => response.json())
			.then(function(data) {
				if (data.success) {
					var bi = toggleLink.querySelector('i');
					if (data.active == 1) {
						toggleLink.classList.remove('link-danger');
						toggleLink.classList.add('link-success');
						bi.classList.remove('bi-x-lg');
						bi.classList.add('bi-check-lg');
					} else {
						toggleLink.classList.add('link-danger');
						toggleLink.classList.remove('link-success');
						bi.classList.add('bi-x-lg');
						bi.classList.remove('bi-check-lg');
					}
				}
				if (data.message) {
					addToast(data.message.type, data.message.text);
				}
			});
		});
	});

	// delete
	list.querySelectorAll('[data-delete]').forEach(function(deleteLink) {
		deleteLink.addEventListener('click', function(event) {
			event.preventDefault();

			let msg = deleteLink.dataset.confirm === undefined || deleteLink.dataset.confirm == '' ? 'Voulez-vous supprimer cet élément ?' : deleteLink.dataset.confirm;
			if (window.confirm(msg)) {
				let formData = new FormData();
				formData.append('action', 'delete');
				formData.append('id', deleteLink.dataset.delete);

				fetch('', {
					method: 'POST',
					headers: { 'X-Requested-With': 'XMLHttpRequest' },
					body: new URLSearchParams(formData)
				})
				.then(response => response.json())
				.then(function(data) {
					if (data.success) {
						reloadList(list);
					}
					if (data.message) {
						addToast(data.message.type, data.message.text);
					}
				});
			}
		});
	});

	// show / hide flags
	list.querySelectorAll('.toggle_contactslist_flags').forEach(function(flagLink) {
		flagLink.addEventListener('click', function(event) {
			event.preventDefault();
			list.classList.toggle('show_contactslist_flags');
		});
	});

	// flag
	list.querySelectorAll('[data-flag][data-contact]').forEach(function(flagLink) {
		flagLink.addEventListener('click', function(event) {
			event.preventDefault();

			let msg = flagLink.dataset.confirm === undefined || flagLink.dataset.confirm == '' ? 'Voulez-vous activer cet élément ?' : flagLink.dataset.confirm;
			if (window.confirm(msg)) {
				let formData = new FormData();
				formData.append('action', 'activateflag');
				formData.append('flag', flagLink.dataset.flag);
				formData.append('contact', flagLink.dataset.contact);

				fetch('', {
					method: 'POST',
					headers: { 'X-Requested-With': 'XMLHttpRequest' },
					body: new URLSearchParams(formData)
				})
				.then(response => response.json())
				.then(function(data) {
					if (data.success) {
						if (data.hasOwnProperty('dates')) {
							let value = '<div class="mb-2">';
							value += '<a data-bs-toggle="collapse" href="#dates_' + flagLink.dataset.flag + '_' + flagLink.dataset.contact + '"><strong>' + data.dates.length + ' activation' + ( data.dates.length > 1 ? 's' : '' ) + '</strong></a>';
							value += '<div class="collapse" id="dates_' + flagLink.dataset.flag + '_' + flagLink.dataset.contact + '">';
							for (let i = 0; i < data.dates.length; i++) {
								let date = new Date(data.dates[i].date);
								let day = date.getDate();
								if ( day < 10 )
									day = '0' + parseInt(day);
								let month = date.getMonth() + 1;
								if ( month < 10 )
									month = '0' + parseInt(month);
								let year = date.getFullYear();
								let hours = date.getHours();
								if ( hours < 10 )
									hours = '0' + parseInt(hours);
								let minutes = date.getMinutes();
								if ( minutes < 10 )
									minutes = '0' + parseInt(minutes);
								let seconds = date.getSeconds();
								if ( seconds < 10 )
									seconds = '0' + parseInt(seconds);
								let c = '';
								if ( data.dates[i].reponse !== null ) {
									c = data.dates[i].reponse ? ' text-success' : ' text-danger';
								}
								value += '<div class="text-nowrap' + c + '">' + day + '/' + month + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds + ' ' + data.dates[i].user + '</div>';
							}
							value += '</div></div>';
							list.querySelectorAll('[data-flagcontact="' + flagLink.dataset.flag + ',' + flagLink.dataset.contact + '"] .dates').forEach(function(el) {
								el.innerHTML = value;
							});
						}
					}
					if (data.message) {
						addToast(data.message.type, data.message.text);
					}
				});
			}
		});
	});

	list.querySelectorAll('[data-flagconfirm][data-contact]').forEach(function(flagLink) {
		flagLink.addEventListener('click', function(event) {
			event.preventDefault();

			let msg = flagLink.dataset.confirm === undefined || flagLink.dataset.confirm == '' ? 'Voulez-vous activer cet élément ?' : flagLink.dataset.confirm;
			let reponse = window.confirm(msg) ? 1 : 0;
			let formData = new FormData();
			formData.append('action', 'scanqrconfirm');
			formData.append('flag', flagLink.dataset.flagconfirm);
			formData.append('contact', flagLink.dataset.contact);
			formData.append('reponse', parseInt(reponse));
			fetch('', {
				method: 'POST',
				headers: { 'X-Requested-With': 'XMLHttpRequest' },
				body: new URLSearchParams(formData)
			})
			.then(response => response.json())
			.then(function(data) {
				if (data.success) {
					if (data.hasOwnProperty('dates')) {
						let value = '<div class="mb-2">';
						value += '<a data-bs-toggle="collapse" href="#dates_' + flagLink.dataset.flagconfirm + '_' + flagLink.dataset.contact + '"><strong>' + data.dates.length + ' activation' + ( data.dates.length > 1 ? 's' : '' ) + '</strong></a>';
						value += '<div class="collapse" id="dates_' + flagLink.dataset.flagconfirm + '_' + flagLink.dataset.contact + '">';
						for (let i = 0; i < data.dates.length; i++) {
							let date = new Date(data.dates[i].date);
							let day = date.getDate();
							if ( day < 10 )
								day = '0' + parseInt(day);
							let month = date.getMonth() + 1;
							if ( month < 10 )
								month = '0' + parseInt(month);
							let year = date.getFullYear();
							let hours = date.getHours();
							if ( hours < 10 )
								hours = '0' + parseInt(hours);
							let minutes = date.getMinutes();
							if ( minutes < 10 )
								minutes = '0' + parseInt(minutes);
							let seconds = date.getSeconds();
							if ( seconds < 10 )
								seconds = '0' + parseInt(seconds);
							let c = '';
							if ( data.dates[i].reponse !== null ) {
								c = data.dates[i].reponse ? ' text-success' : ' text-danger';
							}
							value += '<div class="text-nowrap' + c + '">' + day + '/' + month + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds + ' ' + data.dates[i].user + '</div>';
						}
						value += '</div></div>';
						list.querySelectorAll('[data-flagcontact="' + flagLink.dataset.flagconfirm + ',' + flagLink.dataset.contact + '"] .dates').forEach(function(el) {
							el.innerHTML = value;
						});
					}
				}
				if (data.message) {
					addToast(data.message.type, data.message.text);
				}
			});
		});
	});

	// emptyflag
	list.querySelectorAll('[data-emptyflag]').forEach(function(flagLink) {
		flagLink.addEventListener('click', function(event) {
			event.preventDefault();

			let msg = flagLink.dataset.confirm === undefined || flagLink.dataset.confirm == '' ? 'Êtes-vous sûr ?' : flagLink.dataset.confirm;
			if (window.confirm(msg)) {
				let formData = new FormData();
				formData.append('action', 'emptyflag');
				formData.append('flag', flagLink.dataset.emptyflag);

				fetch('', {
					method: 'POST',
					headers: { 'X-Requested-With': 'XMLHttpRequest' },
					body: new URLSearchParams(formData)
				})
				.then(response => response.json())
				.then(function(data) {
					if (data.message) {
						addToast(data.message.type, data.message.text);
					}
					list.querySelectorAll('[data-activations="' + flagLink.dataset.emptyflag + '"]').forEach(function(el) {
						el.innerHTML = '0';
					});
				});
			}
		});
	});

	// envoi des badges
	list.querySelectorAll('[data-sendbadges]').forEach(function(link) {
		link.addEventListener('click', function(event) {
			event.preventDefault();
			fetch(link.dataset.sendbadges, {
				method: 'GET',
				headers: { 'X-Requested-With': 'XMLHttpRequest' }
			})
			.then(response => response.text())
			.then(function(data) {
				let div = document.createElement('div');
				div.classList.add('modal', 'fade');
				div.innerHTML = data;
				document.body.appendChild(div);
				const modal = new bootstrap.Modal(div);
				modal.show();
				div.addEventListener('hidden.bs.modal', function (event) {
					modal.dispose();
					div.remove();
				});
				initList(div.querySelector('.list-container'));
				div.querySelector('[data-actionsendbadges]').addEventListener('click', function(event) {
					div.querySelector('.modal-footer .error').textContent = '';
					
					let contacts = [];
					div.querySelectorAll('tbody input[type="checkbox"]:checked').forEach(function(input) {
						contacts.push(input.value);
					});
					if( contacts.length == 0 ) {
						div.querySelector('.modal-footer .error').textContent = 'Aucun contact sélectionné';
						return false;
					}
					div.querySelector('.modal-footer').innerHTML = '<div class="me-auto d-flex align-items-center"><div class="me-3 spinner-border"></div><div><div class="me-3">Envoi <span class="status">en cours</span> : <span class="number"></span> / ' + contacts.length + '</div><div>Erreurs : <span class="number_error">0</span></div></div></div>';
					div.querySelectorAll('input').forEach(function(input) {
						input.disabled = true;
					});

					const preventHideModal = function(event) {
						event.preventDefault();
					};
					div.addEventListener('hide.bs.modal', preventHideModal);

					const preventChangeWindow = function(event) {
						var confirmationMessage = "Si vous quittez vous interromperez l'envoi des badges !";
						e.returnValue = confirmationMessage;
						return confirmationMessage;
					};
					window.addEventListener("beforeunload", preventChangeWindow);

					let compteur = 1;
					for( let i = 0; i < contacts.length; i++ ) {
						let formData = new FormData();
						formData.append('action', 'sendbadge');
						formData.append('contact', contacts[i]);
					
						fetch('', {
							method: 'POST',
							headers: { 'X-Requested-With': 'XMLHttpRequest' },
							body: new URLSearchParams(formData)
						})
						.then(response => response.json())
						.then(function(data) {
							div.querySelector('.modal-footer .number').textContent = compteur;
							if( data.hasOwnProperty('contact') ) {
								const tr = div.querySelector('input[value="' + data.contact + '"]').closest('tr');
								tr.classList.add('table-' + (data.success ? 'success' : 'danger'));
								if( data.hasOwnProperty('message') )
									tr.querySelector('td:last-child').innerHTML = '<span class="text-' + (data.success ? 'success' : 'danger') + '">' + data.message + '</span>';
							}
							if( !data.success ) {
								const errorZone = div.querySelector('.modal-footer .number_error');
								let nb = parseInt(errorZone.textContent);
								errorZone.textContent = nb + 1;
							}

							if( i == contacts.length - 1 ) {
								div.querySelector('.modal-footer .status').textContent = 'terminé';
								div.querySelector('.modal-footer .spinner-border').remove();

								div.removeEventListener('hide.bs.modal', preventHideModal);
								window.removeEventListener("beforeunload", preventChangeWindow);
							}
							compteur++;
						});
					}
				});
			});
		});
	});

	// selection multiple
	const selectall = list.querySelector('[data-selectall]');
	if ( selectall ) {
		selectall.addEventListener('change', function(e) {
			list.querySelectorAll('[data-select]').forEach(function(row) {
				row.checked = selectall.checked;
				row.dispatchEvent(new MouseEvent('change'));
			});
		});
	}

	// selection multiple
	list.querySelectorAll('[data-select]').forEach(function(select) {
		select.addEventListener('click', function(e) {
			e.stopPropagation();
			if ( select.checked && e.shiftKey ) {
				const selects = Array.prototype.slice.call(list.querySelectorAll('[data-select]'));
				let firstIndex = selects.indexOf(list.querySelector('[data-select]:checked'));
				let index = selects.indexOf(select);
				if ( firstIndex == index ) {
					index = selects.indexOf(Array.prototype.slice.call(list.querySelectorAll('[data-select]:checked')).pop());
				}
				for ( let i = firstIndex; i <= index; i++ ) {
					selects[i].checked = true;
					selects[i].dispatchEvent(new MouseEvent('change'));
				}
			} else {
				select.dispatchEvent(new MouseEvent('change'));
			}
		});
		select.addEventListener('change', function(e) {
			if ( select.checked )
				select.closest('tr').classList.add('table-info');
			else
				select.closest('tr').classList.remove('table-info');
			if ( list.querySelectorAll('[data-select]:checked').length ) {
				list.querySelectorAll('.list-bulk-actions button').forEach(function(btn) {
					btn.disabled = false;
				});
			} else {
				list.querySelectorAll('.list-bulk-actions button').forEach(function(btn) {
					btn.disabled = true;
				});
			}
		});
	});

	// bulk delete
	list.querySelectorAll('[data-delete-bulk]').forEach(function(deleteLink) {
		deleteLink.addEventListener('click', function(event) {
			event.preventDefault();

			let msg = deleteLink.dataset.confirm === undefined || deleteLink.dataset.confirm == '' ? 'Voulez-vous supprimer les éléments sélectionnés ?' : deleteLink.dataset.confirm;
			if (window.confirm(msg)) {
				let formData = new FormData();
				formData.append('action', 'deletebulk');
				list.querySelectorAll('[data-select]:checked').forEach(function(el) {
					formData.append('id[]', el.dataset.select);
				});
				fetch('', {
					method: 'POST',
					headers: { 'X-Requested-With': 'XMLHttpRequest' },
					body: new URLSearchParams(formData)
				})
				.then(response => response.json())
				.then(function(data) {
					if (data.success) {
						reloadList(list);
					}
					if (data.message) {
						addToast(data.message.type, data.message.text);
					}
				});
			}
		});
	});


	// bulk toggle
	list.querySelectorAll('[data-toggle-bulk]').forEach(function(toggleLink) {
		toggleLink.addEventListener('click', function(event) {
			event.preventDefault();

			let msg = toggleLink.dataset.confirm === undefined || toggleLink.dataset.confirm == '' ? 'Voulez-vous ' + ( toggleLink.dataset.toggleBulk == 1 ? 'activer' : 'désactiver' ) + ' les éléments sélectionnés ?' : toggleLink.dataset.confirm;
			if (window.confirm(msg)) {
				let formData = new FormData();
				formData.append('action', 'togglebulk');
				formData.append('active', toggleLink.dataset.toggleBulk);
				list.querySelectorAll('[data-select]:checked').forEach(function(el) {
					formData.append('id[]', el.dataset.select);
				});
				fetch('', {
					method: 'POST',
					headers: { 'X-Requested-With': 'XMLHttpRequest' },
					body: new URLSearchParams(formData)
				})
				.then(response => response.json())
				.then(function(data) {
					if (data.success) {
						reloadList(list);
					}
					if (data.message) {
						addToast(data.message.type, data.message.text);
					}
				});
			}
		});
	});

	// bulk badges
	list.querySelectorAll('[data-getbadges-bulk]').forEach(function(badgeLink) {
		badgeLink.addEventListener('click', function(event) {
			event.preventDefault();

			let formData = new FormData();
			formData.append('action', 'badgesbulk');
			formData.append('projet', badgeLink.dataset.getbadgesBulk);
			list.querySelectorAll('[data-select]:checked').forEach(function(el) {
				formData.append('id[]', el.dataset.select);
			});

			document.getElementById('loader_badges').classList.add('active');

			fetch('', {
				method: 'POST',
				headers: { 'X-Requested-With': 'XMLHttpRequest' },
				body: new URLSearchParams(formData),
				responseType: "blob"
			})
			.then((response) => response.blob())
  			.then((x) => {
				const url = URL.createObjectURL(x); 
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'badges.zip');
				document.body.append(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url);
				document.getElementById('loader_badges').classList.remove('active');
			});
		});
	});


	initContactsListTags(list);
	initSortableList(list);
}


function initSortableList(list) {
	const table = list.querySelector('table');
	if (!table)
		return;
	const tbody = table.querySelector('tbody');

	function isIntersecting(min0, max0, min1, max1) {
		return Math.max(min0, max0) >= Math.min(min1, max1) &&
		Math.min(min0, max0) <= Math.max(min1, max1);
	}

	function getStyle(target, styleName) {
		let compStyle = getComputedStyle(target),
		style = compStyle[styleName];
		return style ? style : null;
	}

	var currRow = null,
	dragElem = null,
	mouseDownX = 0,
	mouseDownY = 0,         
	mouseX = 0,
	mouseY = 0,      
	mouseDrag = false;  

	tbody.querySelectorAll('[data-reorder]').forEach(function(btn) {
		btn.addEventListener('mousedown', (event) => {
			if (event.button != 0)
				return true;

			let target = event.target.closest('tr');

			if (target) {
				currRow = target;

				dragElem = target.cloneNode(true);
				dragElem.classList.add('draggable-table__drag');
				for (var i = 0; i < target.children.length; i++) {
					let oldTD = target.children[i],
					newTD = dragElem.children[i];
					newTD.style.width = getStyle(oldTD, 'width');
					newTD.style.height = getStyle(oldTD, 'height');
					newTD.style.padding = getStyle(oldTD, 'padding');
					newTD.style.margin = getStyle(oldTD, 'margin');
				}      

				table.appendChild(dragElem);

				let tPos = target.getBoundingClientRect(),
				dPos = dragElem.getBoundingClientRect();
				dragElem.style.bottom = ((dPos.y - tPos.y) - tPos.height) + "px";

				document.dispatchEvent(new MouseEvent('mousemove', { view: window, cancelable: true, bubbles: true }));

				currRow.classList.add('is-dragging');

				mouseDownX = event.clientX;
				mouseDownY = event.clientY;

				mouseDrag = true;
			}
		});
	});

	document.addEventListener('mousemove', (event) => {
		if (!mouseDrag)
			return;

		mouseX = event.clientX - mouseDownX;
		mouseY = event.clientY - mouseDownY;

		dragElem.style.transform = "translate3d(" + mouseX + "px, " + mouseY + "px, 0)";

		let	dPos = dragElem.getBoundingClientRect(),
		currStartY = dPos.y, currEndY = currStartY + dPos.height,
		rows = table.querySelectorAll('tbody tr');

		for (var i = 0; i < rows.length; i++) {
			let rowElem = rows[i],
			rowSize = rowElem.getBoundingClientRect(),
			rowStartY = rowSize.y, rowEndY = rowStartY + rowSize.height;

			if (currRow !== rowElem && isIntersecting(currStartY, currEndY, rowStartY, rowEndY)) {
				if (Math.abs(currStartY - rowStartY) < rowSize.height / 2) {
					let currIndex = Array.from(tbody.children).indexOf(currRow),
					row1 = currIndex > i ? currRow : rowElem,
					row2 = currIndex > i ? rowElem : currRow;
					tbody.insertBefore(row1, row2);
				}
			}
		}
	});

	document.addEventListener('mouseup', (event) => {
		if (!mouseDrag)
			return;

		currRow.classList.remove('is-dragging');
		table.removeChild(dragElem);
		dragElem = null;
		mouseDrag = false;

		let formData = new FormData();
		formData.append('action', 'reorderflags');
		let ids = [];
		tbody.querySelectorAll('[data-reorder]').forEach(function(el) {
			ids.push(el.dataset.reorder);
		});
		formData.append('ids', ids);

		fetch('', {
			method: 'POST',
			headers: { 'X-Requested-With': 'XMLHttpRequest' },
			body: new URLSearchParams(formData)
		})
		.then(response => response.json())
		.then(function(data) {
			if (data.message) {
				addToast(data.message.type, data.message.text);
			}
		});

	});  
	
}


// import contacts
document.querySelectorAll('[data-importcontacts]').forEach(function(link) {
	link.addEventListener('click', function(event) {
		event.preventDefault();
		fetch(link.dataset.importcontacts, {
			method: 'GET',
			headers: { 'X-Requested-With': 'XMLHttpRequest' }
		})
		.then(response => response.text())
		.then(function(data) {
			let div = document.createElement('div');
			div.classList.add('modal', 'fade');
			div.innerHTML = data;
			document.body.appendChild(div);
			const modal = new bootstrap.Modal(div);
			modal.show();
			div.addEventListener('hidden.bs.modal', function (event) {
				modal.dispose();
				div.remove();
			});

			const formImportContacts = document.getElementById('frm_importcontacts');
			if ( formImportContacts ) {
				const formErrors = document.getElementById('frm_importcontacts_errors');
				const formPreviewTable = document.getElementById('frm_importcontacts_preview_table_contacts');
				const formTotal = document.getElementById('frm_importcontacts_total');

				formImportContacts.querySelectorAll('[data-submit]').forEach(function(btn) {
					btn.addEventListener('click', function(e) {
						e.preventDefault();
						formTotal.innerHTML = '';
						formErrors.innerHTML = '';
						formErrors.classList.remove('mt-3');
						if ( !formImportContacts.checkValidity() ) {
							return false;
						} else {
							formImportContacts.classList.remove('was-validated');
						}

						let formData = new FormData();
						formData.append('action', 'importcontacts');
						formData.append('file', frm_importcontacts.file.files[0]);
						formData.append('allow_email_doublons', frm_importcontacts.allow_email_doublons.checked ? 1 : 0);
						formData.append('update_contacts', frm_importcontacts.update_contacts.checked ? 1 : 0);
						if ( btn.dataset.submit == 'confirm' )
							formData.append('confirm', 1);

						fetch('', {
							method: 'POST',
							//headers: { 'X-Requested-With': 'XMLHttpRequest' },
							body: formData
						})
						.then(response => response.json())
						.then(function(data) {
							if ( data.closemodal ) {
								modal.hide();
								reloadList(document.querySelector('.list-container'));
							} else if (data.success) {
								if (data.total) {
									formTotal.innerHTML = data.total;
								}

								const formPreviewTableHead = formPreviewTable.querySelector('thead');
								let child = formPreviewTableHead.lastElementChild; 
								while (child) {
									formPreviewTableHead.removeChild(child);
									child = formPreviewTableHead.lastElementChild;
								}

								const formPreviewTableBody = formPreviewTable.querySelector('tbody');
								child = formPreviewTableBody.lastElementChild; 
								while (child) {
									formPreviewTableBody.removeChild(child);
									child = formPreviewTableBody.lastElementChild;
								}

								if ( data.contacts.length ) {
									let tr = document.createElement('tr');
									for (let title in data.contacts[0]) {
										let th = document.createElement('th');
										th.textContent = title;
										tr.appendChild(th);
									}
									formPreviewTableHead.appendChild(tr);
								}
								data.contacts.forEach(function(contact) {
									let tr = document.createElement('tr');
									if ( data.hasOwnProperty('doublons') && data.doublons.indexOf(contact.email) != -1 )
										tr.classList.add('table-warning');
									Object.values(contact).forEach(function(val) {
										let td = document.createElement('td');
										td.textContent = val;
										tr.appendChild(td);
									});
									formPreviewTableBody.appendChild(tr);
								});

								formImportContacts.classList.add('preview');
							}
							if (data.message) {
								addToast(data.message.type, data.message.text);
							}
							if (data.error) {
								formErrors.classList.add('mt-3');
								formErrors.innerHTML = data.error;
							}
						});
					});
				});

				formImportContacts.querySelectorAll('[data-cancel]').forEach(function(btn) {
					btn.addEventListener('click', function(e) {
						e.preventDefault();
						formImportContacts.classList.remove('preview');
					});
				});

			}
		});
	});
});
	